const UserGroup = {
  LocqAdmin: "locq_admin",
  Pricetracq: "pricetracq",
  RetailPricing: "seaoil_retail_pricing",
};

export default UserGroup;
